import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { PurchaseOrderStatusEnum } from '../PurchaseOrderStatusEnum'
import { UpdateProductInventoryItemArgs } from '../../product/args/UpdateProductInventoryItemArgs'

@InputType()
export class PurchaseOrderUpdateProductInventoryArgs extends ActionArgs {
  @Field(() => String)
  documentId: string

  @Field(() => [UpdateProductInventoryItemArgs])
  items: UpdateProductInventoryItemArgs[]

  @Field(() => String)
  status?: PurchaseOrderStatusEnum
}
